import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { NotebookSessionService } from '@mode/notebooks/domain';

export const DowngradedNotebooksDomainModule = angular
  .module('downgraded-notebooks-domain', [])
  .service('NotebookSessionService', downgradeInjectable(NotebookSessionService)).name;
